'use strict';
import * as $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn$002dResult from "./app.pages.-Documents-Create-Page$-Based-On-Result.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument(newDocKind, doc) {
  this.Yi = null;
  this.Me = null;
  this.Yi = newDocKind;
  this.Me = doc;
}
export { $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument as $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument };
$p = $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument.prototype = new $j_app$002epages$002e$002dDocuments$002dCreate$002dPage$0024$002dBased$002dOn$002dResult.$h_Lapp_pages_DocumentsCreatePage$BasedOnResult();
$p.constructor = $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument;
/** @constructor */
function $h_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument() {
}
export { $h_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument as $h_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument };
$h_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument)) {
    var x = this.Yi;
    var x$2 = x$0.Yi;
    if ((x === x$2)) {
      var x$3 = this.Me;
      var x$4 = x$0.Me;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "ExistingDocument";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Yi;
  }
  if ((n === 1)) {
    return this.Me;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "newDocKind";
  }
  if ((n === 1)) {
    return "doc";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kq)));
}
export { $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument as $isArrayOf_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument };
var $d_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument, "app.pages.DocumentsCreatePage$BasedOnResult$ExistingDocument", ({
  kq: 1,
  eD: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument as $d_Lapp_pages_DocumentsCreatePage$BasedOnResult$ExistingDocument };
//# sourceMappingURL=app.pages.-Documents-Create-Page$-Based-On-Result$-Existing-Document.js.map
